import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import CardValueSelect from '../shared/CardValueSelect';

type CardAutoloadEditProps = {
  selectedValue: number;
  setSelectedValue: (n: number) => void;
  minimumValue: number;
  maximumValue: number;
  currentCardValue: number;
  next: () => void;
  isValid: boolean;
};

export default function CardAutoloadEdit({
  selectedValue,
  setSelectedValue,
  minimumValue,
  maximumValue,
  currentCardValue,
  isValid,
  next,
}: CardAutoloadEditProps) {
  const [t] = useTranslation('global');

  return (
    <>
      <h1 className="h1 h1plus pb-5 ion-text-center">
        {t('cardautoload.title')}
      </h1>
      <CardValueSelect
        selectedValue={selectedValue}
        minimum={minimumValue}
        maximum={maximumValue}
        currentCardValue={currentCardValue}
        setSelectedValue={setSelectedValue}
      />
      <div className="pt-5 ion-text-center">
        <IonButton
          className={
            'btn-default btn-wide-80 ' + (isValid ? '' : 'btn-disabled')
          }
          onClick={() => next()}
        >
          {t('cardautoload.next')}
        </IonButton>
      </div>
    </>
  );
}
